import { scoreMeta } from "../lib/format";

export function ScoreGauge({ value, size = 150, thickness = 11, label = true, testid }) {
  const v = value ?? 0;
  const meta = scoreMeta(v);
  const r = (size - thickness) / 2;
  const c = 2 * Math.PI * r;
  const off = c * (1 - v / 100);
  const cx = size / 2;
  return (
    <div className="relative inline-flex items-center justify-center" data-testid={testid} style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={cx} cy={cx} r={r} stroke="#1B243B" strokeWidth={thickness} fill="none" />
        <circle
          cx={cx} cy={cx} r={r} stroke={meta.color} strokeWidth={thickness} fill="none"
          strokeDasharray={c} strokeDashoffset={off} strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.9s cubic-bezier(.2,.8,.2,1)", filter: `drop-shadow(0 0 6px ${meta.color}66)` }}
        />
      </svg>
      <div className="absolute flex flex-col items-center">
        <span className="font-mono font-extrabold tnum leading-none" style={{ color: meta.color, fontSize: size * 0.26 }}>
          {v == null ? "—" : Math.round(v)}
        </span>
        {label && <span className="eyebrow mt-1" style={{ color: meta.color }}>{meta.label}</span>}
      </div>
    </div>
  );
}

export function ScoreBar({ value, color, height = 6 }) {
  const meta = scoreMeta(value);
  return (
    <div className="w-full rounded-full bg-[#1B243B] overflow-hidden" style={{ height }}>
      <div className="h-full rounded-full" style={{ width: `${value ?? 0}%`, background: color || meta.color, transition: "width .8s ease" }} />
    </div>
  );
}
